const translations = {
  "en": {
    "Ask": "Ask",
    "for asset-specific reports.": "for asset-specific reports.",
    "Generate": "Generate",
    "Give me more info about this report": "Give me more info about this report",
    "Macro Daily Report": "Macro Daily Report",
    "Macro Daily Report": "Macro Daily Report",
    "Macro Daily Report %{var0}": "Macro Daily Report %{var0}",
    "Market Movers": "Market Movers",
    "Portfolio Tracker": "Portfolio Tracker",
    "Portfolio Tracker %{var0}": "Portfolio Tracker %{var0}",
    "Putting together your report and possible next moves": "Putting together your report and possible next moves",
    "See what Edggy found for your positions today.": "See what Edggy found for your positions today."
  },
  "zh-tw": {
    "Ask": "提問",
    "for asset-specific reports.": "針對特定資產的報告。",
    "Generate": "生成",
    "Give me more info about this report": "了解此報告的更多資訊",
    "Macro Daily Report": "宏觀每日報告",
    "Macro Daily Report": "宏觀每日報告",
    "Macro Daily Report %{var0}": "宏觀每日報告 %{var0}",
    "Market Movers": "領漲榜",
    "Portfolio Tracker": "投資組合追蹤",
    "Portfolio Tracker %{var0}": "投資組合追蹤 %{var0}",
    "Putting together your report and possible next moves": "整理你的報告及可能的下一步行動",
    "See what Edggy found for your positions today.": "看看 Edggy 今天為你的持倉找到的內容。"
  }
};

export default translations;
